import 'babel-polyfill';
import SideSearch from './components/SideSearch';
import ReadMore from './components/ReadMore';
import DomainNav from './components/DomainNav';
import Gallery from './components/Gallery';
import MenuMobile from './components/MenuMobile';
import ScrollTo from './components/ScrollTo';
import Tutorial from './components/Tutorial';
import Form from './components/Form';

export class Main {
  constructor() {
    this.windowSizes = this.getWindowSizes();
    window.onresize = this.onResize.bind(this);

    this.init();
  }

  init() {
    this.initSideSearch();
    this.initDomainNav();
    this.initGallery();
    this.initMenuMobile();
    this.initScrollTo();
    this.initReadMores();
    this.initTutorial();
    this.initForm();
    this.initNavScrollMobile();
  }

  initTutorial() {
    this.tutorial = new Tutorial(this.windowSizes);
  }

  initForm() {
    this.form = new Form(this.windowSizes);
  }

  initMenuMobile() {
    this.menuMobile = new MenuMobile(this.windowSizes);
  }

  initScrollTo() {
    const s = new ScrollTo();
  }

  initSideSearch() {
    this.sideSearch = new SideSearch(this.windowSizes);
    this.sideSearch.init();
  }

  initReadMores() {
    this.readMores = [];
    [...document.querySelectorAll('[read-more]')].forEach((readMoreElem) => {
      this.readMores.push(new ReadMore(readMoreElem, this.windowSizes));
    });
  }

  initDomainNav() {
    this.domainNav = new DomainNav(this.windowSizes);
  }

  initGallery() {
    this.gallery = new Gallery(this.windowSizes);
  }

  initNavScrollMobile() {
    if (this.windowSizes.mobileDevice) {
      const nav = document.querySelector('.nav-domaines__ul');
      if (nav) {
        const current = nav.querySelector('.current-menu-item');
        const currentPage = nav.querySelector('.nav-domaines__li--active');

        if (current) {
          nav.scrollLeft = current.offsetLeft > 30 ? current.offsetLeft : 0;
        }
        if (currentPage) {
          nav.scrollLeft =
            currentPage.offsetLeft > 35 ? currentPage.offsetLeft : 0;
        }
      }
    }
  }

  checkMobile() {
    const isMobile = {
      Android: function () {
        return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function () {
        return (
          navigator.userAgent.match(/IEMobile/i) ||
          navigator.userAgent.match(/WPDesktop/i)
        );
      },
      any: function () {
        return (
          isMobile.Android() ||
          isMobile.BlackBerry() ||
          isMobile.iOS() ||
          isMobile.Opera() ||
          isMobile.Windows()
        );
      },
    };

    return isMobile.any();
  }

  getWindowSizes() {
    const width = window.innerWidth;
    const height = window.innerHeight;

    const mobile = width <= 414 ? true : false;
    const tablet = width <= 980 && width > 414 ? true : false;
    return {
      width: width,
      height: height,
      mobile: mobile,
      tablet: tablet,
      mobileDevice: this.checkMobile(),
    };
  }

  onResize() {
    this.windowSizes = this.getWindowSizes();
    this.gallery.resize(this.windowSizes);
    this.tutorial.resize(this.windowSizes);
    this.readMores.forEach((readmore) => {
      readmore.resize(this.windowSizes);
    });
  }
}

//document.addEventListener("DOMContentLoaded", (e) => new Main());
export let main = new Main();



// WEBPACK FOOTER //
// ./src/js/index.js